<template>
  <b-modal
    ref="airline-etickets-modal-ref"
    hide-footer
    hide-header
    title="Airline E-Ticket Information"
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">Airline E-Ticket Information</h5>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div class="vtd-modal-body">
        <section class="mb-5">
          <p>Airline E-Tickets are electronic and do not exist physically, therefore no airline tickets will be posted to you.</p>
          <p>You will only receive one E-Ticket number for each person, per ticket, not per flight. Where you have multiple tickets on your itinerary, you can identify the E-Ticket number that matches each set of flights by the first two letters of the E-Ticket. This will match the relevant flight number prefixes on your itinerary. </p>
          <p>It is unlikely you will need these E-Ticket numbers. Typically an airline will just ask for your Airline Reference number which can be found under the flight line on ViewTrail. Some airlines allow you to check-in online using your E-Ticket number as an alternative to your Airline Reference.</p>
          <p>Your E-Ticket is not your boarding pass. Your boarding pass is what you will need to board the aircraft - this is generated at check in, either online or in person at the airport.</p>
        </section>
        <section>
          <p v-if="tickets.length === 0">Your ticket numbers will appear here in due course.</p>
          <table border="0" cellpadding="1" cellspacing="0" width="100%" v-if="tickets.length >=1">
            <tbody>
              <tr>
                <th>Ticket Number</th>
                <th>Ticket Name</th>
                <th>Ticket Type</th>
              </tr>
              <tr v-for="ticket in tickets" :key="ticket.ticketno">
                <td class="default" width="40%">{{ ticket.ticketno }}</td>
                <td class="default" width="35%">{{ ticket.name }}</td>
                <td class="default" width="35%">{{ ticket.type }}</td>
              </tr>
            </tbody>
          </table>
          <p v-if="ticketMessage" style="margin: 10px 0px 9px">
            {{ ticketMessage }}
          </p>
        </section>
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small>This information was generated at: <strong>{{ returnDate}}</strong></small>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from '@/lib/dayjs'
export default {
  data() {
    return {
      payload: {},
      tickets: [],
      ticketMessage: "",
    };
  },
  methods: {
    showModal(payload) {
      this.$refs["airline-etickets-modal-ref"].show();
      // If we have data then dont need to recreate it
      this.payload = payload;

      this.tickets = [];
      this.ticketMessage = "";
      const itineraryItem = this.returnTickets(this.itinerary.notes);
      if (itineraryItem) {
        if (itineraryItem.message) {
          this.ticketMessage = itineraryItem.message;
        }
        itineraryItem.tickets.forEach((ticket, index) => {
          this.tickets.push(ticket[`line${index}`]);
        });
      }
    },
    returnTickets(notes) {
      let tickets = notes.filter((note) => {
        if (note.jsontype === "tickets") {
          return note;
        }
      });
      if (tickets) {
        return tickets[0];
      }
    },
    closeModal() {
      this.$refs["airline-etickets-modal-ref"].hide();
    },
  },
  computed: {
    ...mapGetters({ itinerary: "booking/getItineraryRaw" }),
    returnDate(){
      return dayjs().format('DD-MMM-YYYY HH:mm')
    }
  },
};
</script>
<style lang="scss">
@import "./style.scss";
</style>

